<template>
  <v-app id="inspire">
    <v-card-title>
      Media files
      <v-spacer></v-spacer>
      <v-dialog width="unset" height="unset" v-model="dialogs.upload">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="
              uploading = false;
              updatingMedia = false;
            "
            class="ml-5"
            color="secondary"
            v-bind="attrs"
            v-on="on"
            >Upload</v-btn
          >
        </template>
        <v-card class="pa-2" background="white" width="400">
          <v-card-title> Upload media file </v-card-title>
          <v-card-text>
            <v-file-input
              label="Click to browse..."
              accept=".svg, .mp3, .jpeg, .jpg, .png, audio/mpeg, image/jpeg, image/png"
              filled
              show-size
              truncate-length="400"
              prepend-icon="mdi-paperclip"
              clear-icon="mdi-close"
              color="primary"
              v-model="file"
              @change="fileChanged"
            />
          </v-card-text>
          <v-text-field
            class="FileTextField"
            v-model="mediaName"
            label="Name"
            single-line
            hide-details
          ></v-text-field>
          <v-text-field
            class="FileTextField"
            v-model="description"
            label="Description"
            single-line
            hide-details
          ></v-text-field>
          <v-combobox
            v-model="mediaTags"
            label="Tags"
            variant="solo"
            chips
            clearable
            multiple
            class="FileTextField"
          >
          </v-combobox>
              
          <v-select
            v-model="selectedOwner"
            label="Select owner level"
            :items="getOwnerLevel()"
            class="FileTextField"
          ></v-select>
          <v-select
            v-model="selectedOrganization"
            label="Select organization"
            :items="getOrganizations"
            item-text="name"
            class="FileTextField"
            clearable
            persisten-hint
            hide-details
            return-object
          ></v-select>
          <v-card-actions>
            <v-btn
              @click="uploadMedia()"
              right
              :loading="uploading"
              :disabled="uploading || !validFileSpecified || !selectedOwner"
              color="primary"
            >
              Upload
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <span v-if="wrongFileType" class="error"> Please select an allowed file type. svg, png, jpg, mp3, audio </span>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getMediaFiles"
      :hide-default-footer="true"
      disable-pagination
      item-key="mediaFile.id"
    >
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <!-- DELETE and EDit Collection BUTTON-->
        <v-btn icon @click="openEditDialog(item)" color="secondary"
          ><v-icon>mdi-pencil</v-icon></v-btn
        >
        <v-btn icon @click="deleteMediaFile(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
import {
  ADD_OR_UPDATE_MEDIA_FILES,
  GET_MEDIA_FILES_QUERY,
  GET_AUDIO_FILES_QUERY,
  DELETE_MEDIA_FILES,
} from '../../graphql/shootingProgramQueries.js';
import { GET_ORGANIZATIONS } from '../../graphql/organizationQueries';
import { toBase64, OWNER_LEVEL } from '../../utils/Helper.js';

export default {
  components: {
    CConfirmationDialog: () => import('../common/CConfirmationDialog'),
  },
  name: 'MediaFiles',
  data: () => ({
    wrongFileType: false,
    selectedOrganization: {},
    mediaTags: [],
    mediaName: '',
    description: '',
    selectedOwner: null,
    selectedMediaType: null,
    uploading: false,
    updatingMedia: false,
    search: '',
    selectedLanguage: {},
    file: {}, // The file that the user selects/uploads from file input
    base64File: null, // If editing an media file, this will be the already encoded file from the database
    expanded: [],
    dialogs: {
      upload: false,
    },
    testArr: [{ name: 'Norwegian' }, { name: 'English' }],
    headers: [
      { text: 'Name', value: 'jsonData.name' },
      { text: 'Description', value: 'jsonData.description' },
      { text: 'Version', value: 'jsonData.version' },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'right',
      },
    ],
  }),
  created() {},
  apollo: {
    $client: 'shootingProgramClient',
    getMediaFiles: {
      query: GET_MEDIA_FILES_QUERY,
      client: 'shootingProgramClient',
      loadingKey: 'loading',
      options: { fetchPolicy: 'cache-and-network' },
    },
    getAudioFiles: {
      query: GET_AUDIO_FILES_QUERY,
      client: 'shootingProgramClient',
      loadingKey: 'loading',
      options: { fetchPolicy: 'cache-and-network' },
    },
    getOrganizations: {
      client: 'organizationClient',
      query: GET_ORGANIZATIONS,
      loadingKey: 'loading',
    },
  },

  computed: {
    validFileSpecified() {
      if (this.file === undefined) {
        return false;
      }

      return this.file.name !== undefined && this.file.size > 0;
    },
  },
  methods: {
    fileChanged() {
      this.base64File = null;
    },
    getOwnerLevel() {
      return OWNER_LEVEL;
    },
    getMediaTypes(){
      return ['TEXT','IMAGE','AUDIO','VIDEO']
    },
    refetchMediaFiles() {
      this.$apollo.queries.getMediaFiles.refetch();
    },
    async deleteMediaFile(id) {
      if (
        await this.$refs.confirmationDialog.open(
          'Are you sure you want to delete this media file?'
        )
      ) {
        try {
          await this.$apollo.mutate({
            mutation: DELETE_MEDIA_FILES,
            variables: {
              id: id,
            },
          });
        } catch (err) {
          alert('Error deleting media file! ' + err.message);
        }
        this.refetchMediaFiles();
      }
    },
    async uploadMedia() {
      this.wrongFileType = false; 
      if (this.validFileSpecified) {
        try {
          // Set uploading state to indicate that the upload process is ongoing
          this.uploading = true;

          let mediaFile;
          if (this.base64File) {
            mediaFile = this.base64File;
          } else {
            mediaFile = await toBase64(this.file);
          }

          const validBase64 = mediaFile.replace(/^data:.+;base64,/, ''); // Remove data URI scheme

          //Check filetype
          const mimeType = this.file.type;
          let mediaFileInput = "PLAIN";
          let fileName = this.file.name.toLowerCase();

          //Filter accpeted file types
          if(!['.svg','.mp3', '.jpg', '.jpeg', '.png'].some(ext => fileName.endsWith(ext))){
            this.uploading = false;
            this.wrongFileType = true; 
            return;
          }
            

            if (mimeType === 'audio/mpeg' || fileName.endsWith('.mp3')) {
              this.selectedMediaType = 'AUDIO';
              mediaFileInput = "MP3";
            } else if (
              mimeType === 'image/png' || 
              fileName.endsWith('.png')
            ) {
              this.selectedMediaType = 'IMAGE';
              mediaFileInput = "PNG";
            } else if(mimeType === 'image/jpeg' ||
              fileName.endsWith('.jpg') ||
              fileName.endsWith('.jpeg')){
              this.selectedMediaType = 'IMAGE';
              mediaFileInput = "JPG";
            } 
            else if(mimeType === 'image/svg+xml' || fileName.endsWith('.svg')){
              this.selectedMediaType = 'IMAGE';
              mediaFileInput = "SVG";
            }
            else {
              this.selectedMediaType = 'UNKNOWN'; // fallback
            }

          let id = null;
          if (this.mediaName === '')
            this.mediaName = this.file.name.split('.')[0];
          if (this.updatingMedia) {
            id = this.audioId;
          }

          await this.$apollo.mutate({
            mutation: ADD_OR_UPDATE_MEDIA_FILES,
            variables: {
              id: id,
              mediaFile: {
                file: validBase64,
                name: this.mediaName,
                mediaType: this.selectedMediaType,
                mediaFormat: mediaFileInput,
                description: this.description,
                organizationId: this.selectedOrganization?.id,
                owner: {
                  level: this.selectedOwner,
                },
                tags: this.mediaTags,
              },
            },
          });

          this.uploading = false;
          this.file = {};
          this.base64File = null;
          this.description = '';
          this.selectedOwner = null;
          this.mediaName = '';
          this.selectedOrganization = {};
          this.mediaTags = [];
          this.updatingMedia = false;

          this.dialogs.upload = false;

          this.refetchMediaFiles();
        } catch (error) {
          console.error(error);
          this.uploading = false;
        }
      }
    },
    openEditDialog(mediaFile) {
      const org = this.getOrganizations?.filter(
        (g) => g.id == mediaFile.jsonData.organizationId
      );

      this.audioId = mediaFile.id;

      let mimeType = '';
      switch (mediaFile.jsonData.mediaType) {
        case 'AUDIO':
          mimeType = 'audio/mpeg'; 
          break;
        case 'IMAGE':
          mimeType = 'image/png'; 
          break;
        case 'VIDEO':
          mimeType = 'video/mp4'; 
          break;
        case 'TEXT':
          mimeType = 'text/plain'; 
          break;
        default:
          mimeType = 'application/octet-stream';
      }

      this.file = new Blob([mediaFile.file], { type: mimeType });
      this.base64File = mediaFile.file;
      this.file.name = mediaFile.jsonData.name;

      this.description = mediaFile.jsonData.description;
      this.selectedOwner = mediaFile.jsonData.owner.level;
      this.mediaName = mediaFile.jsonData.name;
      if(org)
        this.selectedOrganization = org.length != 0 ? org[0] : null;
      this.mediaTags = mediaFile.jsonData.tags;

      this.updatingMedia = true;
      this.dialogs.upload = true;
    },
  },
};
</script>

<style scoped>
.FileTextField {
  margin: 10px;
}
</style>
